var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ReactComponent as GithubIcon } from 'assets/svg/github-logo.svg';
import { ReactComponent as GoogleIcon } from 'assets/svg/google-logo.svg';
import * as Styled from './SocialAuthButton.styles';
var social = {
    GITHUB: {
        icon: _jsx(GithubIcon, {}, void 0),
        text: 'Github로 로그인',
    },
    GOOGLE: {
        icon: _jsx(GoogleIcon, {}, void 0),
        text: 'Google로 로그인',
    },
};
var SocialLoginButton = function (_a) {
    var provider = _a.provider, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, props = __rest(_a, ["provider", "variant"]);
    return (_jsxs(Styled.SocialLoginButton, __assign({}, props, { type: "button", provider: provider, variant: variant }, { children: [_jsx(Styled.Icon, { children: social[provider].icon }, void 0), variant === 'default' && _jsx(Styled.Text, { children: social[provider].text }, void 0)] }), void 0));
};
export default SocialLoginButton;
